import { API_BASE } from '../constants/api';

/**
 * Aktualisiert den Status eines Alarms (ack/clear) und gibt den neuen Status zurück.
 * Wirft einen Error bei Fehlschlag.
 */
export async function updateAlarmStatusAPI(alarmIdId, action, token) {
  const res = await fetch(`${API_BASE}/alarm/${alarmIdId}/${action}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    throw new Error('Alarmstatus konnte nicht geändert werden');
  }
}
